import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';

import { Image } from 'app/components/Image';
import { BrandAmbassadorPhotoProps } from './BrandAmbassadorPhoto.interface';
import { useStyles } from './BrandAmbassadorPhoto.styles';

export default function BrandAmbassadorPhoto({
  className,
}: BrandAmbassadorPhotoProps) {
  const classes = useStyles();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down(500));

  return (
    <div className={className}>
      <div className={classes.photo}>
        <Image
          className={classes.efoImage}
          alt="Tymek Kucharczyk - pierwsze miejsce w Euroformula Open 2025"
          src="./images/backgrounds/EFO-2025.png"
          srcSetWebp={'./images/backgrounds/EFO-2025.webp'}
          height={47}
          width={56}
        />
        <Image
          alt="Tymek Kucharczyk - kierowca wyścigowy wspierany przez Mubi"
          src="./images/backgrounds/brand-ambassador.png"
          srcSetWebp={'./images/backgrounds/brand-ambassador.webp'}
          height={145}
          width={122}
        />
      </div>
      <div className={classes.photoMobile}>
        <Image
          alt="Tymek Kucharczyk - kierowca wyścigowy wspierany przez Mubi"
          src="./images/backgrounds/brand-ambassador-mobile-laur.png"
          srcSetWebp={'./images/backgrounds/brand-ambassador-mobile-laur.webp'}
          height={isMobile ? 100 : 55}
          width={isMobile ? 109 : 60}
        />
      </div>
    </div>
  );
}
